<template>
  <div class="flex items-center justify-center space-x-2">
    <!-- Previous Button -->
    <button
      :disabled="currentPage === 1"
      @click="goToPage(currentPage - 1)"
      class="px-3 py-1 text-sm border rounded disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Prev
    </button>

    <!-- Page Numbers -->
    <span
      v-for="(page, index) in getPaginationRange()"
      :key="index"
      :class="[
        'px-3 py-1 text-sm border rounded cursor-pointer',
        page === currentPage
          ? 'bg-blue-500 text-white border-blue-500'
          : 'hover:bg-gray-200',
        page === '...' ? 'cursor-default text-gray-500' : ''
      ]"
      @click="goToPage(page)"
    >
      {{ page }}
    </span>

    <!-- Next Button -->
    <button
      :disabled="currentPage === totalPages"
      @click="goToPage(currentPage + 1)"
      class="px-3 py-1 text-sm border rounded disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Next
    </button>
  </div>
</template>
<script>
export default {
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    }
  },
  methods: {
    getPaginationRange() {
      const range = [];
      const { currentPage, totalPages } = this;

      // Always include the first page
      if (currentPage > 0) {
        range.push(1);
        if (currentPage > 4) {
          range.push("...");
        }
      }

      // Add two previous, current, and two upcoming pages
      const startPage = Math.max(2, currentPage - 2);
      const endPage = Math.min(totalPages - 1, currentPage + 2);
      for (let i = startPage; i <= endPage; i++) {
        range.push(i);
      }

      // Always include the last page
      if (currentPage < totalPages - 2) {
        if (currentPage < totalPages - 3) {
          range.push("...");
        }
        range.push(totalPages);
      }

      return range;
    },
    goToPage(page) {
      if (page !== "..." && page !== this.currentPage) {
        this.$emit("page-change", page);
      }
    }
  }
};
</script>
